<template>
    <v-app style="background-color: #f3f6f9">
        <v-main>
           
            <ManuimComp />

        </v-main>
    </v-app>
</template>
<script>
import Auth from '@/services/auth.service.js'
import ManuimComp from '@/components/manuim/ManuimComp.vue'

export default {
    components: {
        ManuimComp
    },
    mounted() {
        document.title = 'מנויים | סים לחומרא'
        let auth = Auth.checkAuth();
        if (!auth) {
            return this.$router.replace({ name: "login" })
        }
    },
}
</script>
<style>
</style>